import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import fetch from "isomorphic-fetch";
import { withPrefix } from "gatsby";

const httpLink = createHttpLink({
  uri: process.env.GATSBY_BACKEND_ADDRESS,
});

const resetToken = onError(({ graphQLErrors, response }) => {
  const errors = graphQLErrors || response?.errors || [];

  const hasInvalidTokenError = errors.some(
    (error) =>
      error?.message === "The token is invalid" ||
      error?.message === "Unable to parse token"
  );

  if (hasInvalidTokenError && typeof window !== "undefined") {
    window.localStorage.clear();
    window.location.assign(withPrefix("/"));
  }
});

const withToken = setContext((_, { headers }) => {
  const token =
    typeof window !== "undefined"
      ? window.localStorage.getItem("zepshop2021")
      : null;

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const authFlowLink = withToken.concat(resetToken);
const link = authFlowLink.concat(httpLink);

export const client = new ApolloClient({
  fetch,
  link,
  credentials: "include",
  cache: new InMemoryCache(),
});